const getCurrentAssignmentDetails = state => state.currentAssignmentDetails;

export default {
  getCurrentAssignmentDetails
};



// WEBPACK FOOTER //
// ./src/store/modules/assignments/getters.js